export default __webpack_public_path__ + "static/media/calendar.8c506423.svg";